import script from "./TripDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TripDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./TripDetailsPage.vue?vue&type=style&index=0&id=b0e1d67a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0e1d67a"]])

export default __exports__